<template>
  <section class="shi-shi-dong-tai">
    <PageBlock title="实时动态">
      <div class="content">
        <div class="title">
          <span></span>
          今日受理量
        </div>
        <div class="value-content">
          <div class="num-item" v-for="(item, index) in value">{{item}}</div>
        </div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";

export default {
  name: 'shi-shi-dong-tai',
  components: {
    PageBlock
  },
  props: {
    realTimeOrderCount: [String,Number]
  },
  computed: {
    value () {
      const paddedStr = this.realTimeOrderCount.toString().padStart(6, '0'); // 补足 6 位
       // 转换为数组并将每个字符转为数字
      return paddedStr.split('').map(Number)
    }
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.shi-shi-dong-tai {
  .content{
    border-radius: 14px;
    background: rgba(102, 255, 255, 0.17);
    padding: 12px 12px 30px 12px;
    margin-top: 10px;
    .title{
      display: flex;
      color: #fff;
      font-size: 16px;
      align-items: center;
      gap: 6px;
      >span{
        width: 12px;
        height: 12px;
        background-color: #66FFFF;
        border-radius: 50%;
      }
    }
    .value-content{
      display: flex;
      gap: 3%;
      margin-top: 10px;
      .num-item{
        width: 60px;
        height: 60px;
        background-color: #122953;
        border-radius: 6px;
        color: #fff;
        text-align: center;
        font-size: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
